<ng-container *ngIf="!singleColor">
  <div class="worklog-part computer" [style.width.%]="computerWidth * 100" [matTooltip]="computerSeconds | durationHms">
  </div>
  <div *ngIf="showMeetingTime" class="worklog-part meeting" [style.width.%]="meetingWidth * 100"
    [matTooltip]="meetingSeconds | durationHms">
  </div>
  <div class="worklog-part manual" [style.width.%]="manualWidth * 100" [matTooltip]="summary?.manual | durationHms">
  </div>
  <div class="worklog-part mobile" [style.width.%]="mobileWidth * 100" [matTooltip]="summary?.mobile | durationHms">
  </div>
  <div class="worklog-part break" [style.width.%]="(unpaidBreakWidth+paidBreakWidth) * 100"
    matTooltipClass="multiline-tooltip" [matTooltip]="breakTooltip">
  </div>
  <div class="worklog-part paid-leave" [style.width.%]="paidLeaveWidth * 100" [matTooltip]="paidLeaveTooltip">
  </div>
  <div *ngIf="timelineReport && unpaidLeavesEnabled" class="worklog-part unpaid-leave"
    [style.width.%]="unpaidLeaveWidth * 100" [matTooltip]="unpaidLeaveTooltip">
    <div class="unpaid-mark-leave"></div>
  </div>
</ng-container>

<ng-container *ngIf="singleColor">
  <div class="worklog-part computer" [style.background]="singleColorValue" [style.width.%]="totalWidth * 100"
    [matTooltip]="summary?.[totalFieldName] | durationHms" [matTooltipDisabled]="hideTooltip">
  </div>
</ng-container>
